import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { subscribeNewsletter } from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubscribe = async (e) => {
    e.preventDefault();
    if (!email.includes("@")) {
      toast.error("Please enter a valid email");
      return;
    }
    try {
      setLoading(true);
      await subscribeNewsletter(email);
      toast.success("You're on the list. We'll be in touch.");
      setEmail("");
    } catch {
      toast.error("Could not subscribe. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer data-testid="footer" className="relative overflow-hidden border-t hairline bg-black">
      <div className="mx-auto max-w-[1400px] px-6 py-24 md:px-12 md:py-32">
        <div className="grid gap-14 md:grid-cols-12">
          <div className="md:col-span-5">
            <span className="overline text-primary">The Sovereign Pilgrimage</span>
            <h3 className="mt-4 font-serif text-4xl leading-none md:text-5xl">
              A once-in-twelve-years <em className="italic text-primary/90">rendezvous</em> with the eternal.
            </h3>
            <form onSubmit={onSubscribe} className="mt-10 flex max-w-md items-end gap-4" data-testid="newsletter-form">
              <div className="flex-1">
                <label className="overline block text-muted-foreground">Receive dispatches</label>
                <input
                  data-testid="newsletter-email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="your@email.com"
                  className="lux-input mt-3 w-full text-lg"
                />
              </div>
              <Button
                data-testid="newsletter-submit"
                type="submit"
                disabled={loading}
                className="rounded-none bg-primary px-6 py-6 text-primary-foreground hover:bg-primary/90"
              >
                <span className="overline">{loading ? "Sending" : "Subscribe"}</span>
              </Button>
            </form>
          </div>

          <div className="grid grid-cols-2 gap-10 md:col-span-7 md:grid-cols-3">
            <div>
              <p className="overline text-primary">Discover</p>
              <ul className="mt-6 space-y-4 font-sans-lux text-sm text-foreground/70">
                <li><Link to="/about" className="hover:text-primary">The Kumbh</Link></li>
                <li><Link to="/packages" className="hover:text-primary">Packages</Link></li>
                <li><Link to="/plan-your-visit" className="hover:text-primary">Plan Your Visit</Link></li>
              </ul>
            </div>
            <div>
              <p className="overline text-primary">Concierge</p>
              <ul className="mt-6 space-y-4 font-sans-lux text-sm text-foreground/70">
                <li>+91 733 000 2028</li>
                <li>concierge@simhastha2028.com</li>
                <li>Available 24 / 7</li>
              </ul>
            </div>
            <div>
              <p className="overline text-primary">Studio</p>
              <ul className="mt-6 space-y-4 font-sans-lux text-sm text-foreground/70">
                <li>Ujjain • Mumbai • Delhi</li>
                <li>Bespoke concierge, since forever</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-24 select-none text-center">
          <p className="font-serif italic text-primary/40 text-sm tracking-widest">
            नमः शिवाय
          </p>
          <h2
            data-testid="brand-mark"
            className="mt-2 font-serif leading-[0.85] tracking-tight"
            style={{ fontSize: "clamp(3rem, 15vw, 12rem)" }}
          >
            SIMHASTHA
          </h2>
        </div>

        <div className="mt-16 flex flex-col items-center justify-between gap-4 border-t hairline pt-8 md:flex-row">
          <p className="font-sans-lux text-xs text-muted-foreground">
            © {new Date().getFullYear()} Simhastha 2028 Concierge. All journeys curated with reverence.
          </p>
          <p className="overline text-muted-foreground">Ujjain · Madhya Pradesh · India</p>
        </div>
      </div>
    </footer>
  );
}
